import React from 'react'
import injectJss from 'react-jss'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const style = theme => ({
    container: {
        width: '300px',
        fontFamily: theme.typography.fontFamily,
        color: theme.palette.common.white,
        textAlign: 'left',
        position: 'absolute',
        bottom: '10px',
        left: ({ leftOffset }) => leftOffset + 'px',
    },
    title: {
        transform: ({ offsetX, offsetY }) => {
            if (offsetX !== undefined && offsetY !== undefined) {
                return `translateX(${-offsetX * 5}px) translateY(${-offsetY * 5}px)`
            } else {
                return 'none'
            }
        },
        transition: 'transform 0.2s',
        transitionTimingFunction: 'linear',
        transitionDelay: '-0.1s',
        position: 'relative',
        fontSize: '32px',
        fontWeight: '500',
        fontStyle: 'normal',
        fontStretch: 'normal',
        width: '200px',
        maxHeight: '68px',
        lineHeight: '1.3',
        marginBottom: '0px',
        paddingBottom: '10px',
        display: 'flex',
        alignItems: 'flex-end',
        overflow: 'hidden',
        zIndex: '600',
        // webkit solution
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: '2',
        // non webkit solution
        position: 'relative',
        textOverflow: 'ellipsis',
        textShadow: '0 4px 6px rgba(0, 0, 0, 0.5)',
        opacity: 0,
        // Mount animation
        animationName: 'mountAnimation',
        animationDuration: '0.1s',
        animationDelay: '-0.10s',
        animationIterationCount: '1',
        animationTimingFunction: 'ease-out',
        animationFillMode: 'forwards',
        userSelect: 'none',
        '@supports not (-webkit-line-clamp: 1)': {
            textAlignt: 'justify',
            paddingRight: '1em',
        },
        '&:after': {
            content: "'...'",
            textAlign: 'right',
            bottom: '0',
            right: '0',
            width: '25%',
            display: 'block',
            position: 'absolute',
            height: 'calc(1em * 1.2)',
            '@supports (-webkit-line-clamp: 1)': {
                display: 'none !important',
            },
        },
        // To handle embedded p tags
        '& > p': {
            margin: 0,
        },
        '& > p > a': {
            color: 'white',
            textDecoration: 'underline',
            '&:hover': {
                textDecorationColor: 'blue',
            },
        },
    },
    description: {
        transform: ({ offsetX, offsetY }) => {
            if (offsetX !== undefined && offsetY !== undefined) {
                return `translateX(${-offsetX * 5}px) translateY(${-offsetY * 5}px)`
            } else {
                return 'none'
            }
        },
        marginBottom: '20px',
        transition: 'transform 0.2s',
        transitionTimingFunction: 'linear',
        transitionDelay: '-0.1s',
        width: '200px',
        fontSize: '15px',
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontStretch: 'normal',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'flex-end',
        // webkit solution
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: '2',
        color: 'white',
        // non webkit solution
        position: 'relative',
        maxHeight: '3em',
        lineHeight: '1.47',
        letterSpacing: 'normal',
        textOverflow: 'ellipsis',
        textShadow: '0 2px 4px rgba(0, 0, 0, 0.8)',
        opacity: 0,
        zIndex: '600',
        // Mount animation
        animationName: 'mountAnimation',
        animationDuration: '0.1s',
        animationDelay: '-0.1s',
        animationIterationCount: '1',
        animationTimingFunction: 'ease-out',
        animationFillMode: 'forwards',
        userSelect: 'none',
        '@supports not (-webkit-line-clamp: 1)': {
            textAlignt: 'justify',
            paddingRight: '1em',
        },
        '&:after': {
            content: "'...'",
            textAlign: 'right',
            bottom: '0',
            right: '0',
            width: '25%',
            display: 'block',
            position: 'absolute',
            height: 'calc(1em * 1.2)',
            '@supports (-webkit-line-clamp: 1)': {
                display: 'none !important',
            },
        },
        // To handle embedded p tags
        '& > p': {
            margin: 0,
        },
        '& > p > a': {
            color: 'white',
            textDecoration: 'underline',
            '&:hover': {
                textDecorationColor: 'blue',
            },
        },
    },
    '@keyframes mountAnimation': {
        '0%': {
            opacity: 0,
            top: 16,
        },
        '100%': {
            opacity: 1,
            top: 0,
        },
    },
})

const PreviewTitleDescription = ({ classes, title, description, isVisible }) => (
    <div className={classes.container}>
        {isVisible && <h1 className={classes.title} dangerouslySetInnerHTML={{ __html: title }} />}
        {isVisible && <div className={classes.description} dangerouslySetInnerHTML={{ __html: description }} />}
    </div>
)

const removePTags = str => str.replace(/(<p[^>]+?>|<p>|<\/p>)/gim, '')

PreviewTitleDescription.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    leftOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isVisible: PropTypes.bool,
}

export default compose(injectJss(style))(PreviewTitleDescription)
